<template>
  <div
    class="dropdown"
    :class="{ 'is-up': isTouchscreenDevice, 'is-active': isActive }"
  >
    <div class="dropdown-trigger">
      <button
        :class="triggerClasses"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click="toggleDropdown"
        @blur="hideDropdown"
      >
        {{ triggerLabel }}
      </button>
    </div>
    <div
      class="dropdown-menu"
      id="dropdown-menu"
      role="menu"
      @mousedown="pinDropDown"
      @mouseup="unPinDropDown"
    >
      <div class="dropdown-content" @click="hideDropdown">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "DropdownMenu",
  props: {
    triggerLabel: {
      type: String,
      default: "⋮",
    },
    triggerClasses: {
      default: () => ["button", "is-small"],
    },
  },
  data() {
    return {
      isActive: false,
      dropdownClickIsInProgress: false,
    };
  },
  methods: {
    toggleDropdown(event) {
      const dropdown = event.target.closest(".dropdown");
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.$emit("dropdownOpened");
      }
    },
    hideDropdown(event) {
      if (!this.dropdownClickIsInProgress) {
        const dropdown = event.target.closest(".dropdown");
        this.isActive = false;
      }
    },
    pinDropDown() {
      this.dropdownClickIsInProgress = true;
    },
    unPinDropDown() {
      this.dropdownClickIsInProgress = false;
    },
  },
  computed: {
    isTouchscreenDevice() {
      return (
        "ontouchstart" in window ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    },
  },
});
</script>
<style scoped>
.dropdown-menu {
  max-width: 85vw;
}
</style>
